import { Box, Button, Typography, useTheme } from '@mui/material';
import { FormSection } from 'components/form';
import { useEffect, useState } from 'react';
import { useFormState } from 'hooks/useFormState';
import { useFormContext } from 'react-hook-form';
import { GridCheckCircleIcon } from '@mui/x-data-grid';

export function CreateDeviceModalRetireDeviceSection() {
    const theme = useTheme();

    const formSectionTitle = 'Retire Device';

    const { setIsFormSubmitDisabled, currentFormSectionIndex, formSections } =
        useFormState();

    const [retireDeviceProcessComplete, setRetireDeviceProcessComplete] =
        useState(false);

    const [shouldRetireDevice, setShouldRetireDevice] = useState(false);

    useEffect(() => {
        if (retireDeviceProcessComplete) {
            setIsFormSubmitDisabled(false);
        } else if (
            currentFormSectionIndex === formSections.indexOf(formSectionTitle)
        ) {
            setIsFormSubmitDisabled(true);
        }
    }, [
        setIsFormSubmitDisabled,
        currentFormSectionIndex,
        formSections,
        retireDeviceProcessComplete,
    ]);

    // get setValue from useFormContext
    const { setValue } = useFormContext();

    // Send patch update to the device with "status": "retired"
    useEffect(() => {
        if (shouldRetireDevice) {
            setValue('shouldRetireDevice', true);
        }
    }, [shouldRetireDevice, setValue]);

    return (
        <FormSection title={formSectionTitle}>
            {retireDeviceProcessComplete ? (
                <Box
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        textAlign: 'center',
                    }}
                >
                    <GridCheckCircleIcon style={{ color: 'green' }} />
                    <Typography style={{ margin: theme.spacing(2) }}>
                        Old device status{' '}
                        {shouldRetireDevice ? <u>will</u> : <u>will not</u>} be
                        set to retired status when deployment is complete.
                    </Typography>
                </Box>
            ) : (
                <Box
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'space-between',
                            justifyContent: 'space-between',
                            textAlign: 'center',
                        }}
                    >
                        <Typography variant="h5" sx={{ margin: '25px 100px' }}>
                            Would you like to set the old device status to
                            retired?
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ margin: '-10px 100px', marginBottom: '25px' }}
                        >
                            <br />
                            Recommended <u>ONLY</u> if the old device will no
                            longer be used. Retired devices can no longer be
                            viewed in your device list. This change to retired
                            status will be permanent.
                        </Typography>
                        <Box
                            // Center the buttons and the loading spinner
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {/* Add two buttons side by side: Yes & No */}
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setShouldRetireDevice(true);
                                    setRetireDeviceProcessComplete(true);
                                }}
                                // Add spacing to the button
                                style={{ margin: theme.spacing(2) }}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setShouldRetireDevice(false);
                                    setRetireDeviceProcessComplete(true);
                                }}
                                // Add spacing to the button
                                style={{ margin: theme.spacing(2) }}
                            >
                                No
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}
        </FormSection>
    );
}
